var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M462.86,361.67C491.07,304.19,493,227.6,473.5,166.2,456.73,113.34,419.41,73,376.31,49,326.3,21.15,266.7,12.86,213,30.44c-14.11,4.62-27.86,8.86-41.17,16.46-54.56,31.14-44,107.88-63.17,134.58-16.11,22.46-46.9,15.84-66.32,33.05C-10,261,20.3,380.69,76.48,423.65,141.89,473.67,393,504,462.86,361.67Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.86,361.67C491.07,304.19,493,227.6,473.5,166.2,456.73,113.34,419.41,73,376.31,49,326.3,21.15,266.7,12.86,213,30.44c-14.11,4.62-27.86,8.86-41.17,16.46-54.56,31.14-44,107.88-63.17,134.58-16.11,22.46-46.9,15.84-66.32,33.05C-10,261,20.3,380.69,76.48,423.65,141.89,473.67,393,504,462.86,361.67Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Studio--inject-6"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 145.88,
    y: 164.39,
    width: 326.89,
    height: 188.14,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 437.94,
    cy: 235.11,
    r: 20.29,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 437.94,
    cy: 235.11,
    r: 11.51,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 437.94,
    cy: 235.11,
    r: 3.29,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 414.36,
    y: 202.49,
    width: 47.15,
    height: 65.24,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 364.47,
    cy: 235.11,
    r: 20.29,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 364.47,
    cy: 235.11,
    r: 11.51,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 364.47,
    cy: 235.11,
    r: 3.29,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.89,
    y: 202.49,
    width: 47.15,
    height: 65.24,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 291,
    cy: 235.11,
    r: 20.29,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 291,
    cy: 235.11,
    r: 11.51,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 291,
    cy: 235.11,
    r: 3.29,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267.43,
    y: 202.49,
    width: 47.15,
    height: 65.24,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 254.48,
    y: 306.66,
    width: 68.51,
    height: 45.88,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 254.48,
    y: 309.1,
    width: 64.23,
    height: 43.43,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.24,
    y: 306.66,
    width: 68.51,
    height: 45.88,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.24,
    y: 309.1,
    width: 64.23,
    height: 43.43,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 241.16,
    y1: 164.9,
    x2: 241.16,
    y2: 352.12,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 359.86,
    cy: 56.63,
    r: 2.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 382.2,
    cy: 56.63,
    r: 2.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 404.54,
    cy: 56.63,
    r: 2.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 426.87,
    cy: 56.63,
    r: 2.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 449.21,
    cy: 56.63,
    r: 2.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 359.86,
    cy: 73.94,
    r: 2.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 382.2,
    cy: 73.94,
    r: 2.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 404.54,
    cy: 73.94,
    r: 2.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 426.87,
    cy: 73.94,
    r: 2.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 449.21,
    cy: 73.94,
    r: 2.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 359.86,
    cy: 91.24,
    r: 2.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 382.2,
    cy: 91.24,
    r: 2.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 404.54,
    cy: 91.24,
    r: 2.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 426.87,
    cy: 91.24,
    r: 2.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 449.21,
    cy: 91.24,
    r: 2.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.46,108.55a2.6,2.6,0,1,1-2.6-2.6A2.6,2.6,0,0,1,362.46,108.55Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.8,108.55a2.6,2.6,0,1,1-2.6-2.6A2.61,2.61,0,0,1,384.8,108.55Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.13,108.55a2.6,2.6,0,1,1-2.59-2.6A2.6,2.6,0,0,1,407.13,108.55Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.47,108.55a2.6,2.6,0,1,1-2.6-2.6A2.6,2.6,0,0,1,429.47,108.55Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.81,108.55a2.6,2.6,0,1,1-2.6-2.6A2.61,2.61,0,0,1,451.81,108.55Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 359.86,
    cy: 125.85,
    r: 2.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 382.2,
    cy: 125.85,
    r: 2.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 404.54,
    cy: 125.85,
    r: 2.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 426.87,
    cy: 125.85,
    r: 2.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 449.21,
    cy: 125.85,
    r: 2.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 359.86,
    cy: 143.16,
    r: 2.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 382.2,
    cy: 143.16,
    r: 2.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 404.54,
    cy: 143.16,
    r: 2.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 426.87,
    cy: 143.16,
    r: 2.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 449.21,
    cy: 143.16,
    r: 2.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 359.86,
    cy: 371.54,
    r: 2.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 382.2,
    cy: 371.54,
    r: 2.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 404.54,
    cy: 371.54,
    r: 2.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 426.87,
    cy: 371.54,
    r: 2.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 449.21,
    cy: 371.54,
    r: 2.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 359.86,
    cy: 388.85,
    r: 2.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 382.2,
    cy: 388.85,
    r: 2.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 404.54,
    cy: 388.85,
    r: 2.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 426.87,
    cy: 388.85,
    r: 2.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 449.21,
    cy: 388.85,
    r: 2.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 359.86,
    cy: 406.15,
    r: 2.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 382.2,
    cy: 406.15,
    r: 2.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 404.54,
    cy: 406.15,
    r: 2.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 426.87,
    cy: 406.15,
    r: 2.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 449.21,
    cy: 406.15,
    r: 2.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 359.86,
    cy: 423.46,
    r: 2.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 382.2,
    cy: 423.46,
    r: 2.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 404.54,
    cy: 423.46,
    r: 2.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 426.87,
    cy: 423.46,
    r: 2.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 449.21,
    cy: 423.46,
    r: 2.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 359.86,
    cy: 440.76,
    r: 2.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 382.2,
    cy: 440.76,
    r: 2.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 404.54,
    cy: 440.76,
    r: 2.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 426.87,
    cy: 440.76,
    r: 2.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 449.21,
    cy: 440.76,
    r: 2.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 359.86,
    cy: 458.07,
    r: 2.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 382.2,
    cy: 458.07,
    r: 2.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 404.54,
    cy: 458.07,
    r: 2.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 426.87,
    cy: 458.07,
    r: 2.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 449.21,
    cy: 458.07,
    r: 2.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 248.01,
    cy: 371.54,
    r: 2.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 270.35,
    cy: 371.54,
    r: 2.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 292.68,
    cy: 371.54,
    r: 2.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 315.02,
    cy: 371.54,
    r: 2.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 337.36,
    cy: 371.54,
    r: 2.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 248.01,
    cy: 388.85,
    r: 2.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 270.35,
    cy: 388.85,
    r: 2.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 292.68,
    cy: 388.85,
    r: 2.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 315.02,
    cy: 388.85,
    r: 2.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 337.36,
    cy: 388.85,
    r: 2.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 248.01,
    cy: 406.15,
    r: 2.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 270.35,
    cy: 406.15,
    r: 2.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 292.68,
    cy: 406.15,
    r: 2.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 315.02,
    cy: 406.15,
    r: 2.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 337.36,
    cy: 406.15,
    r: 2.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 248.01,
    cy: 423.46,
    r: 2.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 270.35,
    cy: 423.46,
    r: 2.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 292.68,
    cy: 423.46,
    r: 2.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 315.02,
    cy: 423.46,
    r: 2.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 337.36,
    cy: 423.46,
    r: 2.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 248.01,
    cy: 440.76,
    r: 2.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 270.35,
    cy: 440.76,
    r: 2.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 292.68,
    cy: 440.76,
    r: 2.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 315.02,
    cy: 440.76,
    r: 2.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 337.36,
    cy: 440.76,
    r: 2.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 248.01,
    cy: 458.07,
    r: 2.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 270.35,
    cy: 458.07,
    r: 2.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 292.68,
    cy: 458.07,
    r: 2.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 315.02,
    cy: 458.07,
    r: 2.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 337.36,
    cy: 458.07,
    r: 2.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 136.16,
    cy: 371.54,
    r: 2.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 158.49,
    cy: 371.54,
    r: 2.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.83,
    cy: 371.54,
    r: 2.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 203.17,
    cy: 371.54,
    r: 2.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225.5,
    cy: 371.54,
    r: 2.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 136.16,
    cy: 388.85,
    r: 2.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 158.49,
    cy: 388.85,
    r: 2.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.83,
    cy: 388.85,
    r: 2.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 203.17,
    cy: 388.85,
    r: 2.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225.5,
    cy: 388.85,
    r: 2.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 136.16,
    cy: 406.15,
    r: 2.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 158.49,
    cy: 406.15,
    r: 2.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.83,
    cy: 406.15,
    r: 2.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 203.17,
    cy: 406.15,
    r: 2.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225.5,
    cy: 406.15,
    r: 2.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 136.16,
    cy: 423.46,
    r: 2.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 158.49,
    cy: 423.46,
    r: 2.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.83,
    cy: 423.46,
    r: 2.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 203.17,
    cy: 423.46,
    r: 2.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225.5,
    cy: 423.46,
    r: 2.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 136.16,
    cy: 440.76,
    r: 2.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 158.49,
    cy: 440.76,
    r: 2.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.83,
    cy: 440.76,
    r: 2.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 203.17,
    cy: 440.76,
    r: 2.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225.5,
    cy: 440.76,
    r: 2.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 136.16,
    cy: 458.07,
    r: 2.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 158.49,
    cy: 458.07,
    r: 2.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.83,
    cy: 458.07,
    r: 2.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 203.17,
    cy: 458.07,
    r: 2.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225.5,
    cy: 458.07,
    r: 2.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M423.26,352.58l-1.86-55.27a89.09,89.09,0,0,0-12.49-2.5,63.91,63.91,0,0,0-10.18.2L391,300.77l-5.2,51.81Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.73,352.58c-2-8.35-9.88-40.33-11.05-43.16-1.34-3.27-32.77-15.33-32.77-15.33l4.57,58.49Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.42,313.47s.45-2.92,2.95-1.77,6.69,7,7.65,4.87S424,306,422.25,302s.88-5.23-.47-6.57-5.87-1.3-5.87-1.3Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.23,292.51s-.58,17.67,2.3,22.09,12.11,7.11,15.57-1.53a54.49,54.49,0,0,0,3.46-17.87S396,291.35,396.23,292.51Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.25,352.58,397,296s-10.95,4.42-20.37,7.11-14.6,6.72-15.56,8.64-10.19,25.75-12.49,29.21-2.69,5.38-4.23,6.91a74.85,74.85,0,0,1-6.13,4.74Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.94,352.31c1.18-8.31,2.86-19,4.05-27.34",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.42,294.24s-4.8,4-5.38,6.53-1.15,8.26-3.46,10.76-5,5.19-3.26,5a9,9,0,0,0,5.18-2.89c1.73-1.73,6.15-1.73,6.15-1.73L397,296Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.13,247.3s-5.4,7-5.09,11.14,1.6,23.86,3.5,28.31,2.55,10.18,7.64,12.41,14.95,1.59,16.86-2.55,4.45-15.9,4.77-18.77S424.72,261,424.72,261s3.82-2.22,3.82-3.5-7-5.72-7-5.72,2.86-3.5,1.27-5.73-15.9-1.59-15.9-1.59,2.22-3.18-2.87-3.18S395.13,247.3,395.13,247.3Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.23,264.87s2.73-1.71,6.49.68",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.51,264.87a6,6,0,0,1,7.18.68",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.54,251.76s2.86-3.5,1.27-5.73-15.9-1.59-15.9-1.59,2.22-3.18-2.87-3.18-8.91,6-8.91,6-5.4,7-5.09,11.14c.15,1.83.48,6.75,1,12,.07-.48.65-4.35.94-8.23.32-4.13,2.55-7.31,4.46-7.95s2.22,3.18,7.95,3.5,8.27-5.09,11.77-2.86,2.23,8.91,2.23,10.81,3.81,2.23,3.81,3.5c0,1,.83,4.53.82,7,.52-4.62,1.73-15.29,1.73-15.29s3.82-2.22,3.82-3.5S421.54,251.76,421.54,251.76Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.81,277.84v0C422.67,278.27,422.67,278.35,422.81,277.84Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.51,270.41c0,1.06-.47,1.92-1.05,1.92s-1.06-.86-1.06-1.92.47-1.92,1.06-1.92S400.51,269.35,400.51,270.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.66,270.8c0,1.06-.48,1.92-1.06,1.92s-1.06-.86-1.06-1.92.48-1.93,1.06-1.93S411.66,269.73,411.66,270.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.23,269.83s-3.07-2.88-3.46,1.54,4,7.3,4,7.3Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.51,270.41s4-2.5,4,1.15-5,9.61-5,9.61Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.53,268.49a32.18,32.18,0,0,1-1,4.8c-.58,1.73-4.61,3.46-1.92,4.81a10.61,10.61,0,0,0,6.15.57",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.87,282.71c-3.46-2.88-9.23-4.61-13.45-2.88s-7.11,7.87-7.11,7.87L394,288c1.57,4.23,2.51,9.16,7.15,11.19,5.09,2.22,14.95,1.59,16.86-2.55a49.78,49.78,0,0,0,2.29-7.1A21.2,21.2,0,0,0,414.87,282.71Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.14,293.16c-.77.58-1.54,8.46-1,9.61s4.23,5.19,5,3.46a5.36,5.36,0,0,1,1.34-2.12l1.73.77s-.38,5,3.46,6.92l3.84,1.92s9.8,25.17,14.22,31.71a32.56,32.56,0,0,0,6.2,7.15h12.45c2-3,1.29-8.1-2.7-12.92-5.57-6.72-17.87-19.6-21.52-24.21a70.1,70.1,0,0,1-6-8.84l-.57-.77s-2.89-9.6-4.23-14.6-2.69-6.15-5.19-6.72-7.68-2.5-7.68-.2,5.57,3.27,6.34,3.65,2.11,5.38,2.11,5.38S413.91,292.59,413.14,293.16Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Microphone--inject-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M265,74s-1.51-18.76,6-27c8.65-9.57,26.73-17.43,41.06-.39s10.45,46.87,10.84,60c.26,8.85,4.26,17.05,19,19.76",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 233.42,
    cy: 150.33,
    rx: 25.51,
    ry: 30.06,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259.84,
    y: 87.01,
    width: 10.48,
    height: 14.58,
    style: {
      fill: "#696969",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "270.32 87.01 259.84 87.01 263.51 72.43 266.65 72.43 270.32 87.01",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.64,
    y: 96.57,
    width: 26.88,
    height: 39.18,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "274.49 174.47 255.68 174.47 251.64 135.29 278.52 135.29 274.49 174.47",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "283.99 113.89 248 113.89 238.68 125.18",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.36,113.88a4.56,4.56,0,1,0-4.55,4.56A4.55,4.55,0,0,0,290.36,113.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 388.44,
    y1: 136.5,
    x2: 447.07,
    y2: 149.42,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 340.53,
    y1: 125.94,
    x2: 388.44,
    y2: 136.5,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 9
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 285.81,
    y1: 113.88,
    x2: 340.53,
    y2: 125.94,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.24,129.83H371.9a0,0,0,0,1,0,0V160.5a6.22,6.22,0,0,1-6.22,6.22h-1.22a6.22,6.22,0,0,1-6.22-6.22V129.83A0,0,0,0,1,358.24,129.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 364.78,
    y1: 158.81,
    x2: 364.78,
    y2: 467.9,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinejoin: "round",
      strokeWidth: 6
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M166.45,128.67c1,0,16.3,2.66,21.28-8.31s-11.63-9.64-12.63-19.29,13.63-12.63,6.32-22.94-25.27-5-30.93-1-10.3-.33-18.28-5-30.59,11.3-30.59,11.3a46.79,46.79,0,0,0-24.94,7c-12,7.65-10,20.62-11.64,25.61s-26.93,2-32.92,11,2,18,1.33,24.27-16.62,7-15.63,20.95,19.62,20,16.3,25.6-8.32,11-2.66,18.62,22.94,13.64,35.91,12,29.26-23.94,38.24-23.94,32.91,10,42.22,1.67,4.33-23.94-1-31.26-6-30.26.33-38.24S166.45,128.67,166.45,128.67Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.16,326.47c0,14.64-4,41-7,51.24s-2.19,38.79-2.56,56c-.29,13.84.6,28.84,1,34.2H206.43c-1-4.79-2.79-14.79-5.75-34.2-4.76-31.11-15.74-76.86-17.21-81.61S171,317.32,170.66,291a436.69,436.69,0,0,1,1.47-44.65s38.06,14.64,51.6,15.74,23.79.37,28.19-7.69,0-17.93-11.72-23.42-42.09-17.2-53.8-24.89-13.91-13.17-26.72-15-23.79-.74-37-2.2-21.6-1.46-21.6-1.46A157.93,157.93,0,0,1,57.94,200.2c-12.85,1.89-22,19-19.4,37.69S64.16,311.83,64.16,326.47Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.73,262.05c13.55,1.1,23.79.37,28.19-7.69s0-17.93-11.72-23.42-42.09-17.2-53.8-24.89-13.91-13.17-26.72-15-23.79-.74-37-2.2-21.6-1.46-21.6-1.46A157.93,157.93,0,0,1,57.94,200.2c-12.85,1.89-22,19-19.4,37.69s25.62,73.94,25.62,88.58-4,41-7,51.24a71.5,71.5,0,0,0-1.79,13.65c18.26,8.66,63.72,22.46,136.15-5.09-3.81-17.43-7.3-31.64-8.09-34.18C182,347.33,171,317.32,170.66,291a436.69,436.69,0,0,1,1.47-44.65S210.19,261,223.73,262.05Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.56,386.27c-.95-4.33-1.88-8.46-2.75-12.26-10.77,4.45-27.45,9.4-52.8,13-43.93,6.27-69.42-1.9-79.46-6.41a99.22,99.22,0,0,0-1.14,10.74C73.67,400,119.13,413.82,191.56,386.27Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "172.13 246.31 174.71 229.3 181.92 249.41 172.13 246.31",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.88,264.18s19.48,49.25,35.51,51S86.83,249.29,84,243a139.62,139.62,0,0,0-8-14.32",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.61,312.19,89.2,368.46s5.76,1,15.93,2a73.47,73.47,0,0,0,19-.68l.67-4.07-4.4-58.64Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.91,202s17.2,46.11,17.2,73.56-.37,91.5-.37,91.5-11.34,1.83-20.86.37-15.37-2.2-15.37-2.2S98.93,296.09,92.34,250s-9.52-55.26-9.52-55.26a12.15,12.15,0,0,1,7-13.55C98.93,176.77,109.91,202,109.91,202Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.91,202s-1.28-2.94-3.32-6.63c-4.17-2.91-7.84-5.27-8.81-5.36-2.48-.23-8.1-.23-9-.23L82.6,192a11.52,11.52,0,0,0,.22,2.69s.7,2.17,2.16,9.65c10,4.69,22.52,10.22,30,12.44C112.11,207.94,109.91,202,109.91,202Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.57,267.44s-1,25.43-1.35,47.8,2,50.85,2,50.85l28.48-9.83V345.07l-14.92-80.34Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.33,205.69s19,42.82,19,76.49,2.93,81.25,2.93,81.25L186,351.72s-7.32-77.23-19.77-106.87-23.42-47.95-23.42-47.95Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.53,178.24s8.05,11,9.51,14.64,1.1,6.22-1.46,9.51-9.52,14.64-15.37,15.74-22.5-7.74-30.92-15.06-10.44-19.71-7.51-27,8-16.84,12.44-17.2S135.53,178.24,135.53,178.24Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.67,196.17A50.1,50.1,0,0,0,141,197.63",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.38,175.31a36.75,36.75,0,0,0-8,10.61c-3.29,6.59-3.66,10.25-3.66,10.25s-10-2.51-16.83-7.32A30.1,30.1,0,0,1,100.76,172s2.19-16.83,9.51-22.69S141.38,175.31,141.38,175.31Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.69,185.24a36.76,36.76,0,0,1,7.69-9.93s-23.79-31.84-31.11-26a15.65,15.65,0,0,0-3.16,3.6C108.86,158.83,115.38,176.11,133.69,185.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.74,260.22c6.95,0,14.27-2.2,15.74-11.35s-5.13-29.64-20.86-43.55-43.56-32.94-47.22-38.8S176.15,149,175.06,142.37s-8.42-16.47-8.42-16.47-2.56,29.28-4.39,33.3,2.56,5.49,8.05,9.89S186,196.9,194.09,210.44s23.79,37,29.64,40.63",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.67,200.28c-15.95-13.13-38-28.58-41.27-33.76-3.66-5.85-10.25-17.56-11.34-24.15s-8.42-16.47-8.42-16.47-2.56,29.28-4.39,33.3,2.56,5.49,8.05,9.89S186,196.9,194.09,210.44c1.82,3.07,4,6.64,6.44,10.37,1.36-.55,2.85-1.19,4.54-1.95C213.22,215.18,222.88,205.46,227.67,200.28Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.44,104.24s15.17,9,18,15.17,4.74,26.08,1.42,37.93-7.58,23.7-13.75,23.23-26-6.36-31.76-10.43c-5.55-3.94-13.27-12.8-14.22-17.54s3.79-12.33,9-15.17,10.9-6.17,11.85-11.38,1.9-9.48,7.11-9.48S147.91,115.62,147.44,104.24Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.17,133.22s-5.13,2.56-10.25,1.1",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.36,121.87s-8.05-2.93-13.54,3.66",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.78,122.6s2.56-3.66,4.76-.73",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.68,146.76s4.76-.73,7-4-4-7.32-6.22-11.34.36-8.79.36-8.79",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.37,132.12a12.11,12.11,0,0,1-5.12.73",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.05,154.08s-13.91,4-13.91,6.22,7.32,4.76,9.52,3.3S156.39,157.74,160.05,154.08Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.43,83.48a23,23,0,0,0-11,.7c-2.72,10.89-6,33.4,3.13,61.08l9.88-3.21C94.08,113.53,99.23,90.83,101.43,83.48Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 99.62,
    cy: 144.13,
    rx: 18.62,
    ry: 19.45,
    transform: "translate(-55.81 63.25) rotate(-27.86)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 99.62,
    cy: 144.13,
    rx: 13.32,
    ry: 13.92,
    transform: "translate(-55.81 63.26) rotate(-27.86)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.34,179.33s2.2,5.49,4.39,9.52.73,8.78.73,8.78,0,1.1,2.2,11.35c3,13.88,4.1,28.37,5.49,42.47,1.67,16.89,5.51,52.95-12.81,63.3-15,8.46-24.42-14.13-24.12-24.9a89.74,89.74,0,0,1,6-28.54c4.76-12.44,8.59-52,8.23-55.62S74.77,183,71.84,176.41s-4.75-10.25-2.19-14.64,12.44-15,12.44-15,7.32-10.25,7.32.37a49.79,49.79,0,0,1-4,8.05l-5.13,7.68s8.42-4.39,10.62-8.78S96,146.39,97.1,149s0,5.85-2.2,10.61S88,172,88,172Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80.99,
    y1: 147.86,
    x2: 71.84,
    y2: 162.86,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.52,268.8c-15.32,1.64-26-3.07-32.35-7.32a89.58,89.58,0,0,0-6,28.37c-.3,10.77,9.17,33.36,24.12,24.9C105.62,307.25,107.26,286.23,106.52,268.8Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg4);
export default __webpack_public_path__ + "static/media/4.1a8b44f6257c1f5caf5909269a7f4afd.svg";
export { ForwardRef as ReactComponent };